import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type VouchersSortOption = "newest" | "oldest" | "amountHigh" | "amountLow";

export const DEFAULT_VOUCHERS_SORT_OPTION: VouchersSortOption = "newest";

const OPTIONS: SortOption<VouchersSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "amountHigh", label: "Amount (High to Low)" },
  { value: "amountLow", label: "Amount (Low to High)" },
];

export function vouchersSortOptionLabel(option: VouchersSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function vouchersSortOptionToParams(option: VouchersSortOption): {
  sortBy: "createdAt" | "amount";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "amountHigh":
      return { sortBy: "amount", sortOrder: "DESC" };
    case "amountLow":
      return { sortBy: "amount", sortOrder: "ASC" };
  }
}

export default function SortVouchersPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: VouchersSortOption;
  setSortOption: (option: VouchersSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Vouchers"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
